export default __webpack_public_path__ + "img/remove-icon.95b7ceae.svg";